import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { reactChildrenValidator } from '../../../validators/react-children';
import { defaultEventContextAssets, eventContextAssetsValidator } from './assets';
import { defaultEventContextDisplayText, eventContextDisplayTextValidator } from './display-text';
export const defaultEventContextProps = {
    eventId: undefined,
    displayText: defaultEventContextDisplayText,
    assets: defaultEventContextAssets,
    children: undefined
};
export const eventContextPropsValidator = Validator.object({
    eventId: nonEmptyStringValidator,
    displayText: eventContextDisplayTextValidator,
    assets: eventContextAssetsValidator,
    children: reactChildrenValidator
});
